import dedent from 'ts-dedent'
import {
  ColumnDataType,
  GetOutputSchemasParams,
  Provider,
  TableSchemasList,
  WorkflowComponentCodeParams,
  WorkflowComponentParamType
} from '../types'
import { addColumn, removeColumn } from '../utils/schemas'
import { SelectWorkflowComponent } from './common/selectcomponent'
import { SINGLE_OUTPUT_NAME } from './common/singleoutputcomponent'

class Unnest extends SelectWorkflowComponent {
  constructor() {
    super(
      {
        name: 'native.unnest',
        group: 'Aggregation',
        title: 'Unnest',
        description: `
        This component unnests the arrays contained in a column.
    `,
        starred: true
      },
      [
        {
          name: 'source',
          type: WorkflowComponentParamType.InputTable,
          title: 'Source table'
        },
        {
          name: 'col',
          type: WorkflowComponentParamType.Column,
          title: 'Column',
          parent: 'source'
        },
        {
          name: 'arraytype',
          type: WorkflowComponentParamType.Selection,
          title: 'Array inner type',
          options: Object.values(ColumnDataType)
        }
      ]
    )
  }

  getInnerSql({ params, connection }: WorkflowComponentCodeParams) {
    switch (connection.type) {
      case Provider.BigQuery:
        return `
    SELECT * EXCEPT (${params.col})
    FROM ${connection.quoteName(params.source as string)}, UNNEST (${
          params.col
        }) ${params.col}_unnested`
      case Provider.DatabricksRest:
        return dedent`
    SELECT /*+ REPARTITION(40) */
      * EXCEPT (${params.col}), EXPLODE (${params.col}) AS ${
          params.col
        }_unnested
    FROM ${connection.quoteName(params.source as string)}`
      default:
        return null
    }
  }

  canProvideOutputSchemas(): boolean {
    return true
  }

  _getOutputSchemas({
    workflow,
    params,
    schemas,
    connection,
    componentName
  }: GetOutputSchemasParams): TableSchemasList {
    const tablename = params.source as string
    const columns = this._getSchemaForTablename(tablename, schemas, connection)
    const fqn = this._getDryRunOutputTableFqn(
      workflow,
      params,
      connection,
      componentName,
      SINGLE_OUTPUT_NAME
    )
    const arraytype = connection.dataProviderTypeToColumnType(
      params.arraytype as string
    )
    let schema = addColumn(columns, {
      name: `${params.col}_unnested`,
      type: arraytype
    })
    schema = removeColumn(schema, params.col as string)
    return [
      {
        fqn,
        schema
      }
    ]
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  getVersion(provider: Provider): string {
    return '2'
  }
  supportedProviders(): Provider[] {
    return [Provider.BigQuery, Provider.DatabricksRest]
  }
}

export { Unnest }
